const initialState = {
  error: '',
  data: null,
};

export const setInterviewSession = (state, { payload }) => {
  const { data, error } = payload;
  return {
    ...state,
    data,
    error,
  };
};

export default initialState;
